<template>
  <section>
    <div class="block">
      <b-radio v-model="$store.state.property.stage" v-for="stage in stages" :key="stage" v-bind:native-value="stage" @input="updateStage(stage)">
        <i v-bind:class="stageStyle(stage)" aria-hidden="true"></i>
        <br>{{ stage }}
      </b-radio>
    </div>
  </section>
</template>

<script>
import store from "@/store";
import Helpers from "@/services/Helpers.js";

export default {
  data() {
    return {
      stages: Helpers.getStages(),
      preUpdated: true
    };
  },
  updated() {
    this.preUpdated = false;
  },
  methods: {
    stageStyle(stage) {
      return Helpers.getStageStyle(stage);
    },
    updateStage(stage) {
      if (!this.preUpdated) {
        var propertyId = store.state.property.id;
        store.dispatch("updatePropertyStage", { propertyId, stage });
        store.commit("SET_LIBERATOR_SUCCESS", `Stage changed to ${stage}`);
      }
    }
  }
};
</script>

<style>
</style>
